module.exports = __webpack_public_path__ + "static/header_img_1920x480px-9cf257b1e12c480b45f1d580a88ea443.jpg";